import { render, staticRenderFns } from "./etapa_1.vue?vue&type=template&id=4f6e4e43&scoped=true&"
import script from "./etapa_1.vue?vue&type=script&lang=js&"
export * from "./etapa_1.vue?vue&type=script&lang=js&"
import style0 from "./etapa_1.vue?vue&type=style&index=0&id=4f6e4e43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6e4e43",
  null
  
)

export default component.exports